import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    period: checkText(settings),
});

export const PeriodSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formPeriod">
                <Form.Label>Gewünschter Zeitraum</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gewünschten Zeitraum eingeben"
                    type="text"
                    name="period"
                    value={values.period}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.period && !errors.period}
                    isInvalid={touched.period && errors.period}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.period}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};